import { render } from "./Details.vue?vue&type=template&id=1e65b4b2&scoped=true"
import script from "./Details.vue?vue&type=script&lang=js"
export * from "./Details.vue?vue&type=script&lang=js"

import "./Details.vue?vue&type=style&index=0&id=1e65b4b2&scoped=true&lang=scss"

import exportComponent from "/Users/johan/dev/litteraturkartan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e65b4b2"]])

export default __exports__